import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "../../../adapter-vue";
import {
  TUITranslateService,
  TUIStore,
  StoreName,
} from "@tencentcloud/chat-uikit-engine";
import TUICore, { TUIConstants } from "@tencentcloud/tui-core";
import { TUIGlobal } from "@tencentcloud/universal-api";
import Icon from "../../common/Icon.vue";
import addSVG from "../../../assets/icon/add.svg";
import backSVG from "../../../assets/icon/back.svg";
import { isPC } from "../../../utils/env";
import { debounce } from "../../../utils/lodash";
import { IContactSearchResult } from "../../../interface";
import { departmentSearch } from "@/api";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const searchingPlaceholder = TUITranslateService.t("TUIContact.输入ID");
const isSearching = ref<boolean>(false);
const searchValue = ref<string>("");
const searchResult = ref<IContactSearchResult>({
  user: {
    label: "联系人",
    list: [],
  },
  group: {
    label: "群聊",
    list: [],
  },
});

const changeContactSearchingStatus = debounce(function (status: boolean) {
  isSearching.value = status;
}, 200);

const search = async () => {
  if (!searchValue.value) {
    return;
  }
  searchResult.value.user.list = [];
  departmentSearch({ name: searchValue.value }).then((res) => {
    let list = res.data.list.filter((item: any) => item.status == 1);
    if (list.length === 0)
      return Toast({
        message: TUITranslateService.t("TUIGroup.该用户不存在"),
        type: TOAST_TYPE.ERROR,
      });
    for (let index = 0; index < list.length; index++) {
      TUICore.callService({
        serviceName: TUIConstants.TUISearch.SERVICE.NAME,
        method: TUIConstants.TUISearch.SERVICE.METHOD.SEARCH_USER,
        params: {
          userID: list[index].tencent_accid,
        },
      })
        .then((res: any) => {
          searchResult.value.user.list = searchResult.value.user.list.concat(
            res.data
          );
        })
        .catch((error: any) => {
          searchResult.value.user.list = [];
          console.warn("search user error", error);
        });
    }
  });
  TUICore.callService({
    serviceName: TUIConstants.TUISearch.SERVICE.NAME,
    method: TUIConstants.TUISearch.SERVICE.METHOD.SEARCH_GROUP,
    params: {
      groupID: searchValue.value,
    },
  })
    .then((res: any) => {
      searchResult.value.group.list = [res.data.group];
    })
    .catch((error: any) => {
      searchResult.value.group.list = [];
      console.warn("search group error", error);
    });
};
watch(
  () => searchResult.value,
  () => {
    TUIStore.update(
      StoreName.CUSTOM,
      "currentContactSearchResult",
      searchResult.value
    );
  },
  {
    deep: true,
    immediate: true,
  }
);
watch(
  () => isSearching.value,
  () => {
    TUIStore.update(
      StoreName.CUSTOM,
      "currentContactSearchingStatus",
      isSearching.value
    );
    if (isSearching.value) {
      searchValue.value = "";
      searchResult.value.user.list = [];
      searchResult.value.group.list = [];
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

TUIGlobal.updateContactSearch = search;
TUIGlobal.closeSearching = () => {
  isSearching.value = false;
};

return { __sfc: true,searchingPlaceholder, isSearching, searchValue, searchResult, changeContactSearchingStatus, search, TUITranslateService, Icon, addSVG, backSVG, isPC }
}

})